<div>
    <div mat-dialog-title class="title d-flex flex-row justify-content-between pt-2">
        <a (click)="onNoClick()">X</a>
    </div>
    <div mat-dialog-content>
        <a class="d-flex justify-content-center check" href="{{data.url}}" target="_blank">
            <img src="{{data.src}}" class="img-fluid">
        </a>
    </div>
</div>
